
export type StepProgress = typeof StepProgress[keyof typeof StepProgress];


export const StepProgress = {
  Pending: 'Pending',
  Started: 'Started',
  InProgress: 'InProgress',
  Aborted: 'Aborted',
  Declined: 'Declined',
  Completed: 'Completed',
} as const;
